import { render, staticRenderFns } from "./HomeRecommend.vue?vue&type=template&id=21a78e2e&"
import script from "./HomeRecommend.vue?vue&type=script&lang=js&"
export * from "./HomeRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('21a78e2e', component.options)
    } else {
      api.reload('21a78e2e', component.options)
    }
    module.hot.accept("./HomeRecommend.vue?vue&type=template&id=21a78e2e&", function () {
      api.rerender('21a78e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/HomeRecommend.vue"
export default component.exports